import { Globe, MapPin } from "lucide-react";
import { LinkedInIcon } from "@shared/components/brand-icons";
import { SourceFavicon } from "@shared/components/source-favicon";
import { hostOf, linkedinCompanySearchUrl, mapsSearchUrl, pappersSearchUrl } from "@shared/lib/source-links";
import { cn } from "@shared/lib/utils";
import { useT } from "@shared/client/locale";

const orgLink =
  "inline-flex h-7 items-center gap-1.5 rounded-md border px-2.5 text-[12.5px] text-foreground hover:bg-muted [&_svg]:size-3.5";

/**
 * Ce que l'on va chercher de toute façon avant d'écrire : le site, la page
 * LinkedIn de l'entreprise, sa fiche légale et son adresse. Sans page connue,
 * LinkedIn ouvre une recherche par le nom. Fiche d'un lead (app) comme d'un
 * prospect (admin).
 */
export function OrgLinks({
  organization,
  className,
}: {
  organization: { name: string; website: string | null; linkedin_url?: string | null };
  className?: string;
}) {
  const t = useT();
  return (
    <div className={cn("flex flex-wrap items-center gap-1.5", className)}>
      {organization.website && (
        <a className={orgLink} href={organization.website} rel="noreferrer" target="_blank">
          <Globe aria-hidden="true" className="text-muted-foreground" /> {hostOf(organization.website) ?? organization.website}
        </a>
      )}
      <a
        className={orgLink}
        href={organization.linkedin_url || linkedinCompanySearchUrl(organization.name)}
        rel="noreferrer"
        target="_blank"
      >
        <LinkedInIcon /> LinkedIn
      </a>
      <a className={orgLink} href={pappersSearchUrl(organization.name)} rel="noreferrer" target="_blank">
        <SourceFavicon size={14} url="https://www.pappers.fr" /> Pappers
      </a>
      <a className={orgLink} href={mapsSearchUrl(organization.name)} rel="noreferrer" target="_blank">
        <MapPin aria-hidden="true" className="text-muted-foreground" /> {t.leads.orgLinks.map}
      </a>
    </div>
  );
}
